"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Hashtable_1 = require("../Collections/HashMap/Hashtable");
var Calendar_1 = require("../Utils/Calendar");
var ObjectDeveloper_1 = require("../Utils/ObjectDeveloper");
var ObjUtils_1 = require("../Utils/ObjUtils");
var StringUtils_1 = require("../Utils/StringUtils");
var Utils_1 = require("../Utils/Utils");
var XoneConnDataFlags_1 = require("./XoneConnDataFlags");
var Guid_1 = require("../Utils/Guid");
var XoneConnectionData = /** @class */ (function () {
    /**
     * Crea una conexión con el nombre que se le indica.
     *
     * @param Name  Nombre de la conexión a crear.
     * @param Owner Aplicación a la cual pertenece la conexión.
     */
    function XoneConnectionData(Name, Owner) {
        /**
         * Nombre de la conexión
         */
        this.m_strName = "";
        /**
         * Prefijo de las tablas con esta conexión.
         */
        this.m_strPrefix = "";
        /**
         * Separador para encerrar nombres de tablas (apertura)
         */
        this.m_strTableQuoteOpen = "";
        /**
         * Separador para encerrar nombres de tablas (cierre)
         */
        this.m_strTableQuoteClose = "";
        /**
         * Separador para encerrar nombres de campos (apertura)
         */
        this.m_strFieldQuoteOpen = "";
        /**
         * Separador para encerrar nombres de campos (cierre)
         */
        this.m_strFieldQuoteClose = "";
        if (StringUtils_1.default.IsEmptyString(Name)) {
            this.m_strName = XoneConnectionData.MAIN_CONNECTION;
        }
        else {
            this.m_strName = Name;
        }
        // Guardar el propietario
        this.m_owner = Owner;
        // ADD TAG Crear el objeto para el developer
        this.m_developer = new ObjectDeveloper_1.default();
        // Valores por defectos para los nombres de los campos y demás
        this.m_strRowIdFieldName = "ROWID";
        this.m_strSqlFieldName = "SQL";
        //        this.m_nOperIdLength = 50;
        /*
         * TODO ADD TAG 04/05/2015 Juan Carlos:
         * Subo el límite de 50 a 100, en principio
         * es código muy viejo y realmente ni hace falta.
         */
        this.m_nOperIdLength = 100;
        this.m_nRowIdLength = 35;
        // Crear la lista de InitStrings
        this.m_lstInitStrings = new Array();
        // M11051201: Mecanismo para soporte multilenguaje en los componentes y demás cosas.
        this.m_messages = Owner.getMessageHolder();
        // A13080703: Mecanismo para adicionar propiedades extendidas a las conexiones.
        this.m_extendedProperties = new Hashtable_1.default();
        // TAG 20050205: Luis: exponer metodos script en esta clase
        //this.addJavascriptFunctions();
    }
    XoneConnectionData.prototype.PrepareFilter = function (strSQL) {
        throw new Error("Method not implemented.");
    };
    // A13080703: Mecanismo para adicionar propiedades extendidas a las conexiones.
    // TAG 20050204: Luis: exponer en los script las propiedades extendidas del conmstring para tratarlas
    // esto permite agregar dinamicamente por script propiedades al connstring
    //@ScriptAllowed
    XoneConnectionData.prototype.addExtendedProperty = function (key, value) {
        if (this.m_extendedProperties == null) {
            this.m_extendedProperties = new Hashtable_1.default();
        }
        this.m_extendedProperties.put(key, value);
        return 0;
    };
    // TAG 20050204: Luis: exponer en los script las propiedades extendidas del conmstring para tratarlas
    // esto permite agregar dinamicamente por script propiedades al connstring
    //@ScriptAllowed
    XoneConnectionData.prototype.removeExtendedProperty = function (key) {
        if (this.m_extendedProperties != null) {
            if (this.m_extendedProperties.containsKey(key)) {
                this.m_extendedProperties.delete(key);
            }
        }
        return 0;
    };
    // TAG 20050204: Luis: exponer en los script las propiedades extendidas del conmstring para tratarlas
    // esto permite agregar dinamicamente por script propiedades al connstring
    //@ScriptAllowed
    XoneConnectionData.prototype.getExtendedProperty = function (key) {
        if (this.m_extendedProperties == null) {
            return null;
        }
        if (!this.m_extendedProperties.containsKey(key)) {
            return null;
        }
        return this.m_extendedProperties.get(key);
    };
    XoneConnectionData.prototype.getExtendedList = function () {
        return this.m_extendedProperties;
    };
    /**
     * Expone el nombre de la conexión.
     *
     * @return Devuelve el nombre de la conexión.
     */
    XoneConnectionData.prototype.getName = function () {
        return this.m_strName;
    };
    /**
     * Expone o asigna valor al prefijo de las tablas en esta conexión.
     *
     * @return Devuelve el prefijo de las tablas en esta conexión.
     */
    XoneConnectionData.prototype.getPrefix = function () {
        return this.m_strPrefix;
    };
    /**
     * Asigna valor al prefijo de datos de las tablas en esta conexión.
     *
     * @param value Nuevo valor del prefijo.
     */
    XoneConnectionData.prototype.setPrefix = function (value) {
        this.m_strPrefix = value;
        this.m_nFlags |= XoneConnDataFlags_1.default.PREFIX_MODIFIED;
    };
    /**
     * Expone o asigna valor al nodo XML con los datos de la conexión
     *
     * @return Devuelve el nodo XML del que se hayan sacado los datos de esta conexión.
     */
    XoneConnectionData.prototype.getNodeData = function () {
        return this.m_xmlNodeData;
    };
    /**
     * A11092603: Permitir que la maquinaria utilice transacciones si la conexión lo permite.
     *
     * @return TRUE si la conexión soporta transacciones.
     */
    XoneConnectionData.prototype.supportsTransactions = function () {
        return this.m_bSupportsTransactions;
    };
    /**
     * Asigna un nodo de datos XML para sacar de él los datos de declaración de la conexión
     *
     * @param value Nodo XML con los datos de la conexión.
     */
    XoneConnectionData.prototype.setNodeData = function (value) {
        if (null != (this.m_xmlNodeData = value)) { // Sacar algunas cosas del nodo
            // A11111101: Soportar plataformas a nivel de nodos de conexión.
            // Comprobar si tiene nodo platform
            if (!StringUtils_1.default.IsEmptyString(this.m_strPlatform)) {
                this.m_platform = this.m_xmlNodeData.SelectSingleNode("platform", "name", this.m_strPlatform);
            }
            var str = "";
            // A11111101: Soportar plataformas a nivel de nodos de conexión.
            // Sacar los valores usando GetNodeValue
            // El prefijo se puede definir según la sintaxis antigua
            //////if (!StringUtils.IsEmptyString(str = XmlUtils.GetNodeAttr(this.m_xmlNodeData, "prefix")))
            if (!StringUtils_1.default.IsEmptyString(str = this.GetNodeValue("prefix"))) {
                this.setPrefix(str);
            }
            // Los tags para encerrar nombres de campos y tablas
            //////if (!StringUtils.IsEmptyString(str = XmlUtils.GetNodeAttr(this.m_xmlNodeData, "tablequote")))
            if (!StringUtils_1.default.IsEmptyString(str = this.GetNodeValue("tablequote"))) { // Sacar los datos
                if (str.length == 1) { // Los dos son iguales
                    this.setTableQuoteOpen(str);
                    this.setTableQuoteClose(str);
                } // Los dos son iguales
                else { // Diferentes
                    this.setTableQuoteOpen(str.substring(0, 1));
                    // F09042201:	Substring no funciona igual en java que en .NET Arreglar Blackberry
                    this.setTableQuoteClose(str.substring(1, str.length));
                } // Diferentes
            } // Sacar los datos
            //////if (!StringUtils.IsEmptyString(str = XmlUtils.GetNodeAttr(this.m_xmlNodeData, "fieldquote")))
            if (!StringUtils_1.default.IsEmptyString(str = this.GetNodeValue("fieldquote"))) { // Sacar los datos
                if (str.length == 1) { // Los dos son iguales
                    this.setFieldQuoteOpen(str);
                    this.setFieldQuoteClose(str);
                } // Los dos son iguales
                else { // Diferentes
                    this.setTableQuoteOpen(str.substring(0, 1));
                    // F09042201:	Substring no funciona igual en java que en .NET Arreglar Blackberry
                    this.setTableQuoteClose(str.substring(1, str.length));
                } // Diferentes
            } // Sacar los datos
            // A11092603: Permitir que la maquinaria utilice transacciones si la conexión lo permite.
            // Ver si soportamos transacciones o no
            //////m_bSupportsTransactions =StringUtils.ParseBoolValue(this.m_xmlNodeData.getAttrValue("transactions"), false);
            this.m_bSupportsTransactions = StringUtils_1.default.ParseBoolValue(this.GetNodeValue("transactions"), false);
            // F11041502:	Como parte  de la asignación del nodo XML sacar la cadena de conexión.
            //////if (!StringUtils.IsEmptyString(str =this.m_xmlNodeData.getAttrValue("connstring")))
            if (!StringUtils_1.default.IsEmptyString(str = this.GetNodeValue("connstring"))) {
                this.m_strConnString = str;
            }
            if (!StringUtils_1.default.IsEmptyString(str = this.GetNodeValue("datemask"))) {
                this.setDatemask(str);
            }
        } // Sacar algunas cosas del nodo
    };
    /**
     * Expone o asigna valor a la cadena de conexión
     *
     * @return Devuelve la cadena de conexión para este objeto.
     */
    // TAG 20050207: Luis: exponer el connstring a la humanidad para que puedan utilizarlo
    //@ScriptAllowed
    XoneConnectionData.prototype.getConnString = function () {
        return this.m_strConnString;
    };
    /**
     * Asigna valor a la cadena de conexión de este objeto.
     *
     * @param value Nuevo valor para la cadena de conexión.
     */
    // TAG 20050207: Luis: exponer el connstring a la humanidad para que puedan utilizarlo
    //@ScriptAllowed
    XoneConnectionData.prototype.setConnString = function (value) {

        var parsedConnectionString = this.parseConnectionString(value);
        
                        var sDateMask =parsedConnectionString.get("datemask");
                        if (sDateMask) 
                            this.setDatemask(sDateMask);
                        
                        // Tag 23041801 Luis Para poder agregar en la conexion a traves de atributos el rowidfieldname y el sqlfieldname
                        var sRowidFieldName =parsedConnectionString.get("rowidfieldname");
                        if (sRowidFieldName) 
                            this.setRowIdFieldName(sRowidFieldName);
                        var sSqlFieldName =parsedConnectionString.get("sqlfieldname");
                        if (sSqlFieldName) 
                            this.setSqlFieldName(sSqlFieldName);
                        this.m_strConnString = value;
                        this.m_nFlags |= XoneConnDataFlags_1.default.CONNSTRING_MODIFIED;
    };
    XoneConnectionData.prototype.parseConnectionString = function (sConnectionString) {
            var keyValuePair = new Hashtable_1.default();
            sConnectionString.split(";").forEach(function (sParameter) {
                var item = sParameter.split('=');
                item.length > 1 && keyValuePair.put(item[0].trim().toLowerCase(), item.length > 0 ? item[1].trim() : "");
                //             let separatorIndex = sParameter.indexOf('=');
                //             if (separatorIndex != -1 && (sParameter.length > (separatorIndex + 1))) {
                //                 let sKey = sParameter.substring(0, separatorIndex).toLowerCase();
                //                 if (!TextUtils.isEmpty(sKey)) {
                //                     sKey = sKey.trim();
                //                 }
                //                 let sValue = sParameter.substring(separatorIndex + 1);
                //                 if (!TextUtils.isEmpty(sValue)) {
                //                     sValue = sValue.trim();
                //                 }
                // //                if (keyValuePair.containsKey(sKey)) {
                // //                    throw new RuntimeException("Duplicate key " + sKey + " in connection string " + sConnectionString);
                // //                }
                //                 keyValuePair.put(sKey, sValue);
                // }
            });
            return keyValuePair;
        };
    /**
     * Expone o asigna valor a la banderilla que indica si la conexión replica o no.
     *
     * @return Devuelve la bandera que indica si esta conexión está replicando o no.
     */
    XoneConnectionData.prototype.getIsReplicating = function () {
        return this.m_bIsReplicating;
    };
    /**
     * Asigna valor a la bandera que indica si la conexión está replicando o no.
     *
     * @param value TRUE para indicar que la conexión replica a la hora de ejecutar sentencias SQL.
     */
    XoneConnectionData.prototype.setIsReplicating = function (value) {
        this.m_bIsReplicating = value;
    };
    /**
     * Expone o asigna valor al MID que va a usar esta conexión para replicar
     *
     * @return Devuelve el valor del MID asignado a esta conexión.
     */
    XoneConnectionData.prototype.getMID = function () {
        return this.m_nMid;
    };
    /**
     * Asigna valor al MID de esta conexión.
     *
     * @param value Nuevo valor del MID para generar ROWIDs y demás cosillas.
     */
    XoneConnectionData.prototype.setMID = function (value) {
        this.m_nMid = value;
    };
    /**
     * Expone o asigna valor al DBID que va a usar esta conexión para replicar
     *
     * @return Devuelve el valor del DBID asignado a esta conexión para la réplica.
     */
    XoneConnectionData.prototype.getDBID = function () {
        return this.m_nDbId;
    };
    /**
     * Asigna valor al DBID usado para generar ROWIDs y cosas por el estilo.
     *
     * @param value Nuevo valor del DBID para esta conexión.
     */
    XoneConnectionData.prototype.setDBID = function (value) {
        this.m_nDbId = value;
    };
    /**
     * Expone o asigna valor al campo ROWID de la base de datos que se va a usar
     *
     * @return Devuelve el nombre del campo ROWID para esta conexión.
     */
    XoneConnectionData.prototype.getRowIdFieldName = function () {
        return this.m_strRowIdFieldName;
    };
    /**
     * Asigna valor al nombre del campo ROWID de esta conexión de datos.
     *
     * @param value Nuevo valor para el nombre del campo ROWID de la conexión.
     */
    XoneConnectionData.prototype.setRowIdFieldName = function (value) {
        this.m_strRowIdFieldName = value;
        if (StringUtils_1.default.IsEmptyString(this.m_strRowIdFieldName)) {
            this.m_strRowIdFieldName = "ROWID";
        }
        else {
            this.m_nFlags |= XoneConnDataFlags_1.default.ROWIDFIELD_MODIFIED;
        }
    };
    /**
     * Expone o asigna valor al campo SQL de la base de datos que se va a usar
     *
     * @return Devuelve el nombre del campo SQL para esta conexión.
     */
    XoneConnectionData.prototype.getSqlFieldName = function () {
        return this.m_strSqlFieldName;
    };
    /**
     * Asigna valor al nombre del campo SQL para esta conexión.
     *
     * @param value Nombre del nuevo campo SQL para esta conexión.
     */
    XoneConnectionData.prototype.setSqlFieldName = function (value) {
        this.m_strSqlFieldName = value;
        this.m_nFlags |= XoneConnDataFlags_1.default.SQLFIELD_MODIFIED;
    };
    /**
     * Expone o asigna valor al tamaño del ROWID en esta conexión
     *
     * @return Devuelve el tamaño del campo ROWID para esta conexión.
     */
    XoneConnectionData.prototype.getRowIdLength = function () {
        return this.m_nRowIdLength;
    };
    /**
     * Asigna valor al tamaño del campo ROWID de esta conexión.
     *
     * @param value Nuevo tamaño del campo ROWID para esta conexión (más de 35)
     */
    XoneConnectionData.prototype.setRowIdLength = function (value) {
        this.m_nRowIdLength = value;
        // No puede ser menor que 35.. es el tamaño mínimo...
        if (this.m_nRowIdLength < 35) {
            this.m_nRowIdLength = 35;
        }
        else {
            this.m_nFlags |= XoneConnDataFlags_1.default.ROWIDLEN_MODIFIED;
        }
    };
    /**
     * Expone o asigna valor al tamaño del OPERID en esta conexión
     *
     * @return Devuelve el tamaño del campo OPERID para esta conexión.
     */
    XoneConnectionData.prototype.getOperIdLength = function () {
        return this.m_nOperIdLength;
    };
    /**
     * Asigna valor al tamaño del campo OPERID de esta conexión.
     *
     * @param value Nuevo tamaño del campo OPERID para esta conexión.
     */
    XoneConnectionData.prototype.setOperIdLength = function (value) {
        this.m_nOperIdLength = value;
        // El tamaño no puede ser menor que el mínimo (50)
        if (this.m_nOperIdLength < 50) {
            this.m_nOperIdLength = 50;
        }
        else {
            this.m_nFlags |= XoneConnDataFlags_1.default.OPERIDLEN_MODIFIED;
        }
    };
    /**
     * Expone la lista de cadenas de inicialización para esta conexión en concreto
     *
     * @return Devuelve una lista de cadenas de inicialización para esta conexión.
     */
    XoneConnectionData.prototype.getInitStrings = function () {
        return this.m_lstInitStrings;
    };
    /**
     * Expone o asigna valor al datemask de esta conexión
     *
     * @return Devuelve la máscara de fecha para esta conexión.
     */
    XoneConnectionData.prototype.getDatemask = function () {
        return this.m_strDatemask;
    };
    /**
     * Asigna valor a la máscara de fecha para esta conexión.
     *
     * @param value Nuevo valor para la máscara de fecha de la conexión.
     */
    XoneConnectionData.prototype.setDatemask = function (value) {
        this.m_strDatemask = value;
        if (!StringUtils_1.default.IsEmptyString(this.m_strDatemask)) {
            this.m_nFlags |= XoneConnDataFlags_1.default.DATEMASK_MODIFIED;
        }
    };
    /**
     * Expone las banderas que indican qué campos se han modificado desde el exterior.
     *
     * @return Devuelve el valor del campo de banderas de la conexión.
     */
    XoneConnectionData.prototype.getFlags = function () {
        return this.m_nFlags;
    };
    /**
     * Separador para encerrar nombres de tablas (apertura)
     *
     * @return Devuelve el separador de inicio para encerrar los nombres de tablas.
     */
    XoneConnectionData.prototype.getTableQuoteOpen = function () {
        return this.m_strTableQuoteOpen;
    };
    /**
     * Asigna valor para el separador de inicio de los nombres de tablas.
     *
     * @param value Caracter o secuencia de caracteres para iniciar los nombres de tablas.
     */
    XoneConnectionData.prototype.setTableQuoteOpen = function (value) {
        if (!StringUtils_1.default.IsEmptyString(this.m_strTableQuoteOpen = value)) {
            this.m_nFlags |= XoneConnDataFlags_1.default.TABLEQUOTE_MODIFIED;
        }
    };
    /**
     * Separador para encerrar nombres de tablas (cierre)
     *
     * @return Devuelve el caracter o secuencia de caracteres para finalizar los nombres de tablas.
     */
    XoneConnectionData.prototype.getTableQuoteClose = function () {
        return this.m_strTableQuoteOpen;
    };
    /**
     * Asigna valor al caracter o secuencia de caracteres para finalizar los nombres de tablas.
     *
     * @param value Nuevo valor para el caracter o secuencia de caracteres de terminación de los nombres de tablas.
     */
    XoneConnectionData.prototype.setTableQuoteClose = function (value) {
        if (!StringUtils_1.default.IsEmptyString(this.m_strTableQuoteClose = value)) {
            this.m_nFlags |= XoneConnDataFlags_1.default.TABLEQUOTE_MODIFIED;
        }
    };
    /**
     * Separador para encerrar nombres de campos (apertura)
     *
     * @return Devuelve el caracter o secuencia de caracteres para iniciar los nombres de campos.
     */
    XoneConnectionData.prototype.getFieldQuoteOpen = function () {
        return this.m_strFieldQuoteOpen;
    };
    /**
     * Asigna valor al caracter o secuencia de caracteres para iniciar los nombres de campos.
     *
     * @param value Nuevo valor para la secuencia de caracteres de inicio de los nombres de campos.
     */
    XoneConnectionData.prototype.setFieldQuoteOpen = function (value) {
        if (!StringUtils_1.default.IsEmptyString(this.m_strFieldQuoteOpen = value)) {
            this.m_nFlags |= XoneConnDataFlags_1.default.FIELDQUOTE_MODIFIED;
        }
    };
    /**
     * Separador para encerrar nombres de campos (cierre)
     *
     * @return Devuelve el caracter o secuencia de caracteres para finalizar los nombres de campos de esta conexión.
     */
    XoneConnectionData.prototype.getFieldQuoteClose = function () {
        return this.m_strFieldQuoteClose;
    };
    /**
     * Asigna valor al caracter o secuencia de caracteres para finalizar los nombres de campos.
     *
     * @param value Nuevo valor del caracter o secuencia de caracteres usados para terminar los nombres de campo.
     */
    XoneConnectionData.prototype.setFieldQuoteClose = function (value) {
        if (!StringUtils_1.default.IsEmptyString(this.m_strFieldQuoteClose = value)) {
            this.m_nFlags |= XoneConnDataFlags_1.default.FIELDQUOTE_MODIFIED;
        }
    };
    /**
     * TRUE si esta conexión soporta subqueries
     *
     * @return Devuelve la bandera que indica si la conexión soporta subqueries.
     */
    XoneConnectionData.prototype.getSubqueries = function () {
        return this.m_bSubqueries;
    };
    /**
     * Asigna valor a la bandera que indica si la conexión soporta subqueries o no.
     *
     * @param value TRUE si la conexión soporta subqueries.
     */
    XoneConnectionData.prototype.setSubqueries = function (value) {
        this.m_bSubqueries = value;
        this.m_nFlags |= XoneConnDataFlags_1.default.SUBQUERIES_MODIFIED;
    };
    /**
     * Prefijo con el guión necesario para sustituir en las macros
     *
     * @return Devuelve el prefijo de las tablas con el guion ya colocado.
     */
    XoneConnectionData.prototype.getDevelopedPrefix = function () {
        // Si no hay prefijo, devolvemos una cadena vacía utilizable
        if (StringUtils_1.default.IsEmptyString(this.m_strPrefix)) {
            return "";
        }
        // De lo contrario el prefijo con el guión
        return this.m_strPrefix + "_";
    };
    /**
     * Esta función obtiene una conexión física a la fuente de datos. Reintenta tantas veces como se indique. Llama a la abstracta GetNewConnection sin parámetros.
     *
     * @param RetryCount Cantidad de veces que se reintenta en caso de que no se pueda obtener ninguna conexión.
     * @return Devuelve la conexión o NULL si no se ha podido crear ninguna.
     * @throws Exception
     */
    XoneConnectionData.prototype.GetRetryConnection = function (RetryCount, ReadOnly) {
        for (var i = 0; i < RetryCount; i++) { // Reintentar varias veces
            var connection = void 0;
            if (null != (connection = this.GetNewConnection(ReadOnly))) {
                return connection;
            }
            // Dormir un poco para esperar
            //Thread.sleep(200);
        } // Reintentar varias veces
        // Na de na
        return null;
    };
    /**
     * Prepara una sentencia SQL sustituyendo las macros que contiene. Utiliza valores FALSE para los parámetros ChkGroup y Prefiltered.
     *
     * @param Sentence Sentencia SQL que se quiere desarrollar.
     * @return Devuelve la sentencia SQL pasada como parámetro con las macros sustituidas (incluido prefijo y demás)
     * @throws Exception
     */
    // public  PrepareSqlString(String Sentence) throws Exception {
    //     return PrepareSqlString(Sentence, false, false);
    // }
    /**
     * Prepara una sentencia SQL sustituyendo las macros que contiene.
     * F13012403: Poner PrepareSqlString a nivel de clase base para que lo usen los hijos.
     * Ahora esto no sería abstracto, sino virtual y tendría implementación propia y común para todos los que heredan
     * de esta clase.
     *
     * @param Sentence    Sentencia SQL o cadena que se quiere desarrollar.
     * @param ChkGroup    TRUE para efectuar verificación de GROUP BY para sustituir WHERE por HAVING.
     * @param Prefiltered TRUE si la sentencia viene prefiltrada, en cuyo caso no se sustituye WHERE por HAVING.
     * @return Devuelve la sentencia original con el operador sustituido.
     * @throws Exception
     */
    XoneConnectionData.prototype.PrepareSqlString = function (Sentence, ChkGroup, Prefiltered) {
        var mn;
        var ent;
        var usr;
        var str;
        var strSQL = Sentence;
        if (strSQL.contains("##")) { // Algo habrá
            // Buscar la empresa activa...
            ent = this.m_owner.getCompany();
            if (strSQL.contains("##ENTID##")) // Tiene la macro de empresa
             { // Empresa
                if (ent != null) {
                    strSQL = StringUtils_1.default.Replace(strSQL, "##ENTID##", ent.GetObjectIdString());
                }
                else {
                    strSQL = StringUtils_1.default.Replace(strSQL, "##ENTID##", "NULL");
                }
            } // Empresa
            if (strSQL.contains("##MID##")) { // MID solo si está replicando
                if (this.m_bIsReplicating) { // Está replicando
                    str = "'" + this.m_nMid + "'";
                    strSQL = StringUtils_1.default.Replace(strSQL, "##MID##", str);
                } // Está replicando
            } // MID solo si está replicando
            if (strSQL.contains("##ENTIDCOLL##")) { // Colección de empresas
                str = this.m_owner.getEntIdColl();
                //
                // Como los valores pueden venir de fuera, solamente consideraría
                // valor único si
                // además de no tener comas no tiene espacios.
                if (StringUtils_1.default.IsEmptyString(str)) {
                    str = "NULL";
                }
                if (!str.contains(",") && !str.contains(" ")) {
                    strSQL = StringUtils_1.default.Replace(strSQL, "=##ENTIDCOLL##", "="
                        + str);
                }
                else {
                    strSQL = StringUtils_1.default.Replace(strSQL, "=##ENTIDCOLL##", " IN (" + str + ")");
                }
            } // Colección de empresas
            if (strSQL.contains("##ENTIDLEVEL##")) { // Colección de
                // empresas
                str = this.m_owner.getEntIdLevel();
                if (StringUtils_1.default.IsEmptyString(str)) {
                    str = "NULL";
                }
                //
                // Con este continúa
                // Como los valores pueden venir de fuera, solamente consideraría
                // valor único si
                // además de no tener comas no tiene espacios.
                if (!str.contains(",") && !str.contains(" ")) {
                    strSQL = StringUtils_1.default.Replace(strSQL, "=##ENTIDLEVEL##", "=" + str);
                }
                else {
                    strSQL = StringUtils_1.default.Replace(strSQL, "=##ENTIDLEVEL##", " IN (" + str + ")");
                }
            } // Colección de empresas
            if (strSQL.contains("##ENTIDOWNER##")) { // ID de la empresa propietaria
                str = this.m_owner.getEntIdOwner();
                if (StringUtils_1.default.IsEmptyString(str)) {
                    str = "NULL";
                }
                strSQL = StringUtils_1.default.Replace(strSQL, "=##ENTIDOWNER##", "=" + str);
            } // ID de la empresa propietaria
            if (strSQL.contains("##CURRID##")) { // Moneda actual
                if (null != (mn = this.m_owner.getCurrency())) {
                    strSQL = StringUtils_1.default.Replace(strSQL, "##CURRID##", mn.GetObjectIdString());
                }
                else {
                    strSQL = StringUtils_1.default.Replace(strSQL, "##CURRID##", "NULL");
                }
            } // Moneda actual
            if (strSQL.contains("##USERID##")) { // ID de usuario
                if (null != (usr = this.m_owner.getUser())) {
                    strSQL = StringUtils_1.default.Replace(strSQL, "##USERID##", usr.GetObjectIdString());
                }
                else {
                    strSQL = StringUtils_1.default.Replace(strSQL, "##USERID##", "NULL");
                }
            } // ID de usuario
            if (strSQL.contains("##USERIDCOLL##")) { // Conjunto de usuarios
                str = this.m_owner.getUserIdColl();
                if (StringUtils_1.default.IsEmptyString(str)) {
                    strSQL = StringUtils_1.default.Replace(strSQL, "=##USERIDCOLL##", " IS NOT NULL");
                }
                else { // Reemplazar por la cadenilla correcta
                    if (str.contains(",")) {
                        str = "=" + str;
                    }
                    else {
                        str = " IN (" + str + ")";
                    }
                    strSQL = StringUtils_1.default.Replace(strSQL, "=##USERIDCOLL##", str);
                } // Reemplazar por la cadenilla correcta
            } // Conjunto de usuarios
        } // Algo habrá
        // A12050301: Adicionar una macro en la conexión para generar un nuevo ROWID.
        // Macro para ROWID.
        if (strSQL.contains("##ROWID##")) { // Tiene ROWID
            strSQL = strSQL.replace("##ROWID##", this.GenerateRowId(Utils_1.Utils.EMPTY_STRING));
        } // Tiene ROWID
        // Sustituir el prefijo
        if (strSQL.contains("##PREF##")) {
            strSQL = StringUtils_1.default.Replace(strSQL, "##PREF##", this.getDevelopedPrefix());
        }
        // Sustituir las comillas
        if (strSQL.contains("##QUOTES##")) {
            strSQL = StringUtils_1.default.Replace(strSQL, "##QUOTES##", "\"");
        }
        // Sustituir macros de fecha en el SQL si es que vienen
        // El Now
        if (strSQL.contains("##")) { // Si quedan cosas
            var dt = new Calendar_1.default();
            // O11011201:	Optimizar un poco PrepareSqlString.
            // Optimizar un poco esto
            if (strSQL.contains("##NOW_TIME##")) { // NOW_TIME
                str = this.DevelopObjectValue(dt);
                strSQL = StringUtils_1.default.Replace(strSQL, "##NOW_TIME##", str);
            } // NOW_TIME
            if (strSQL.contains("##DAY##")) { // DAY
                str = String.format("%d", dt.get(Calendar_1.default.DAY_OF_MONTH));
                strSQL = StringUtils_1.default.Replace(strSQL, "##DAY##", str);
            } // DAY
            if (strSQL.contains("##MONTH##")) { // MONTH
                str = String.format("%d", dt.get(Calendar_1.default.MONTH));
                strSQL = StringUtils_1.default.Replace(strSQL, "##MONTH##", str);
            } // MONTH
            if (strSQL.contains("##YEAR##")) { // YEAR
                str = String.format("%d", dt.get(Calendar_1.default.YEAR));
                strSQL = StringUtils_1.default.Replace(strSQL, "##YEAR##", str);
            } // YEAR
            if (strSQL.contains("##NOW##")) { // NOW
                ObjUtils_1.default.ZeroCalendarTime(dt);
                str = this.DevelopObjectValue(dt);
                // O11011201:	Optimizar un poco PrepareSqlString.
                // Aquí hay replace, así que usarlo
                str = str.replace("00:00:00", ""); ////StringUtils.removeChars(str, "00:00:00");
                ////str = StringUtils.removeChars(str, " ");
                strSQL = StringUtils_1.default.Replace(strSQL, "##NOW##", str);
            } // NOW
            if (strSQL.contains("##NBSP##")) {
                strSQL = StringUtils_1.default.Replace(strSQL, "##NBSP##", " ");
            }
        } // Si quedan cosas
        // Puede que tenga que chequear si usa GROUP BY y no hay subselects
        // Agregar un chequeo si se trata de una cadenilla que viene prefiltrada
        /*
         * F12060703: Quitar sustituciones a nivel de cadena de filtrado en sqls.
         * Esto no
        if (!m_bSubqueries && ChkGroup && !Prefiltered)
        {// Buscar dentro del SQL
            str = strSQL.toLowerCase();
            // K10052601:	Modificación para sustituir WHERE por HAVING en los sql.
            if (str.indexOf("group by ") !=-1 && str.indexOf("where ") !=-1)
            {// Cambiar el WHERE por HAVING
                int wherePos =  str.indexOf("where ");
                int groupPos =  str.indexOf("group by ");
                if (wherePos > groupPos)
                    strSQL = StringUtils.Replace(strSQL, " WHERE ", " HAVING ");
                else
                {
                    String whereClause = strSQL.substring(wherePos, groupPos);
                    String groupClause = strSQL.substring(groupPos);
                    strSQL = strSQL.substring(0, wherePos);
                    strSQL = strSQL + " " + groupClause +  " " + whereClause;
                    strSQL = StringUtils.Replace(strSQL, " WHERE ", " HAVING ");
                }
            }// Cambiar el WHERE por HAVING
        }// Buscar dentro del SQL
        */
        return strSQL;
    };
    /**
     * Dado un nombre de tabla u otro tipo de objeto de base de datos, lo devuelve formateado con su prefijo si este está definido.
     *
     * @param ObjectName Nombre de tabla, query, vista, etc, cuyo nombre se quiere formatear sustituyendo el prefijo, introduciendo los caracteres de inicio y fin, etc.
     * @param Prefix     Prefijo opcional para usar en la sustitución. NULL para usar el que tenga la conexión.
     * @return Devuelve el nombre del objeto ya desarrollado.
     */
    XoneConnectionData.prototype.FixObjectName = function (ObjectName, Prefix) {
        if (Prefix === void 0) { Prefix = null; }
        var str = ObjectName, str1;
        var strPrefix;
        // Esto solo hay que hacerlo si tiene valor
        if (StringUtils_1.default.IsEmptyString(str)) {
            return str;
        }
        strPrefix = this.m_strPrefix;
        // Si trae prefijo de fuera, sobrepasa al calculado dentro
        if (!StringUtils_1.default.IsEmptyString(Prefix)) {
            strPrefix = Prefix;
        }
        // Ahora sí se puede
        if (!StringUtils_1.default.IsEmptyString(str)) { // Solo si tiene nombre
            // Si tiene prefijo y no es la macro de anulación
            if (!StringUtils_1.default.IsEmptyString(strPrefix) && !strPrefix.equals("##NONE##")) { // Tiene prefijo
                if (str.charAt(0) != '.') {
                    str = strPrefix + "_" + str;
                }
            } // Tiene prefijo
        } // Solo si tiene nombre
        // Si lleva comillas ponérselas por qué no
        if (!StringUtils_1.default.IsEmptyString(this.m_strTableQuoteOpen)) { // Montar los separadores
            str1 = String.format("%s%s%s", this.m_strTableQuoteOpen, str, this.m_strTableQuoteClose);
            return str1;
        } // Montar los separadores
        // Devolver tal cual
        return str;
    };
    /**
     * ADD TAG Implemetar Develop Object en la clase base
     * Desarrolla el valor de un objeto y lo devuelve como cadena lista para insertar en una sentencia SQL o un filtro.
     * <p>
     * K12102201: Modificación de DevelopObjectValue para pasar ForceNulls como parámetro.
     * Lo que redefinimos es la función con parámetro porque el resto la verdad es que no nos interesa :-P
     *
     * @param Value Valor que se quiere desarrollar. Se utilizará la máscara de fecha de la conexión.
     */
    // public DevelopObjectValue(Value:any, ForceNulls:boolean=true):string {
    //     return this.m_developer.DevelopObjectValue(Value, this.m_strDatemask, ForceNulls);
    // }
    XoneConnectionData.prototype.DevelopObjectValue = function (Value, format, ForceNulls) {
        if (format == null)
            return this.m_developer.DevelopObjectValue(Value, this.m_strDatemask, true);
        if (typeof format === 'boolean')
            return this.m_developer.DevelopObjectValue(Value, this.m_strDatemask, format);
        return this.m_developer.DevelopObjectValue(Value, format, ForceNulls);
    };
    /**
     * A11092601: Modificaciones para mejorar el soporte de conexiones remotas y demás.
     * Ejecuta una sentencia SQL parseada.
     * <p>
     * K11092601: ExecuteSqlString y similares deben devolver un objeto, que puede ser ResultSet.
     * Cambiar el tipo de resultado.
     *
     * @param Sentence
     * @return
     * @throws Exception
     */
    XoneConnectionData.prototype.ExecuteLocalParsedSql = function (Sentence) {
        return this.ExecuteParsedSql(null, Sentence, false);
    };
    /**
     * A14011501: Optimizaciones para obtener claves numéricas de conexiones sqlite y demás.
     * Devuelve la cantidad de registros que afectó la última operación de modificación de datos
     * si es que tenemos este valor, de lo contrario (por defecto) devuelve -1
     *
     * @param TableName
     * @return
     */
    XoneConnectionData.prototype.LastAffectedRecords = function (TableName) {
        return -1;
    };
    /**
     * A11092603: Permitir que la maquinaria utilice transacciones si la conexión lo permite.
     * A nivel de esta estructura se soportan transacciones.. o no
     *
     * @return Devuelve un objeto indicando el resultado de la transacción... o NULL
     * @throws Exception
     */
    XoneConnectionData.prototype.commit = function () {
        return null;
    };
    /**
     * A11092603: Permitir que la maquinaria utilice transacciones si la conexión lo permite.
     * Soportar transacciones a este nivel también.
     *
     * @throws Exception
     */
    XoneConnectionData.prototype.beginTrans = function () {
    };
    /**
     * A11092603: Permitir que la maquinaria utilice transacciones si la conexión lo permite.
     * Soportar transacciones también a este nivel.
     *
     * @throws Exception
     */
    XoneConnectionData.prototype.rollBack = function () {
    };
    /**
     * A11111101: Soportar plataformas a nivel de nodos de conexión.
     */
    XoneConnectionData.prototype.SetPlatform = function (Platform) {
        this.m_strPlatform = Platform;
    };
    //A11111101: Soportar plataformas a nivel de nodos de conexión.
    //Devuelve un valor de atributo del nodo teniendo en cuenta el platform.
    XoneConnectionData.prototype.GetNodeValue = function (Key) {
        var strValue;
        if (this.m_xmlNodeData == null) {
            return null;
        }
        if (this.m_platform != null) { // Tiene plataforma
            if (!StringUtils_1.default.IsEmptyString(strValue = this.m_platform.getAttrValue(Key))) {
                return strValue;
            }
        } // Tiene plataforma
        // De lo contrario lo sacamos del nodo directamente
        return this.m_xmlNodeData.getAttrValue(Key);
    };
    /**
     * TODO ADD TAG
     * Cancela los procesos asincrónicos o no asincrónicos que haya corriendo en este momento. Quienes
     * estén esperando por algo recibirán códigos de error o timeouts, pero la estructura volverá a estar
     * disponible para efectuar llamadas.
     * <p>
     * La clase base no hace nada.
     *
     * @param flags Dependiendo de la implementación aquí vendrán cositas para parametrizar la cancelación.
     * @return
     */
    XoneConnectionData.prototype.cancelProcesses = function (flags) {
        return 0;
    };
    /**
     * Aqui vamos a abstraer el mecanismo de autenticar en las conexiones online
     * para poder tener un token de session. por ahora lo hacemos por la via sencilla
     * de mandar un metod Auth para arriba pero podemos complicarlo para Auth2 o algo asi
     */
    XoneConnectionData.prototype.getTokenFromAuth = function (login, pass) {
        return Utils_1.Utils.EMPTY_STRING;
    };
    //@ScriptAllowed
    // TAG 20050206: Luis: para la depuracion el valoor por defecto
    XoneConnectionData.prototype.toString = function () {
        return "Connection: " + this.m_strName;
    };
    // // TAG 20050205: Luis: exponer metodos script en esta clase
    // private void addJavascriptFunctions() {
    //     if (lstScriptAllowedMethods.size() <= 0) {
    //         return;
    //     }
    //     for (final Method method : lstScriptAllowedMethods) {
    //         ScriptableObject.putProperty(this, method.getName(), new BaseFunctionJavaMethodWrapper(this, method));
    //     }
    // }
    /**
     * Genera un ROWID para la conexión actual. Emplea los criterios de número de tabla, MID, DBID, etc.
     *
     * @param TableName Nombre de la tabla para la cual se quiere generar el ROWID.
     * @return Devuelve un ROWID respetando los valores de réplica y el tamaño del campo ROWID.
     */
    XoneConnectionData.prototype.GenerateRowId = function (TableName) { return Guid_1.Guid.create().toString(); };
    // TAG 20050205: Luis: exponer metodos script en esta clase
    //private static final ArrayList<Method> lstScriptAllowedMethods = WrapReflection.SafeGetAnnotatedMethods(XoneConnectionData.class, ScriptAllowed.class);
    /**
     * Constante para exponer el nombre de la conexión principal
     */
    XoneConnectionData.MAIN_CONNECTION = "##MAIN_CONNECTION##";
    return XoneConnectionData;
}());
exports.default = XoneConnectionData;

//# sourceMappingURL=XoneConnectionData.js.map
